import { TimeIntervalUnitEnum } from '../common.enum';
import { PostDownloadRedirectionConfig } from '../config.type';

export const defaultPostDownloadRedirectionConfig: PostDownloadRedirectionConfig = {
  mobileUrl: '',
  tabletUrl: '',
  timeInterval: 0,
  timeIntervalUnit: TimeIntervalUnitEnum.DAYS,
};
